"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCandyGuard = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const constants_1 = require("./constants");
const createCandyGuard_1 = require("./generated/instructions/createCandyGuard");
const hooked_1 = require("./hooked");
function createCandyGuard(context, input) {
    const { guards, groups, ...rest } = input;
    const program = context.programs.get('mplCandyGuard');
    const serializer = (0, hooked_1.getCandyGuardDataSerializer)(context, program);
    const data = serializer.serialize({
        guards: guards ?? {},
        groups: groups ?? [],
    });
    return (0, umi_1.transactionBuilder)([
        {
            ...(0, createCandyGuard_1.createCandyGuard)(context, { ...rest, data }).items[0],
            bytesCreatedOnChain: umi_1.ACCOUNT_HEADER_SIZE + constants_1.CANDY_GUARD_DATA + data.length,
        },
    ]);
}
exports.createCandyGuard = createCandyGuard;
//# sourceMappingURL=createCandyGuard.js.map